export default __webpack_public_path__ + "static/media/img-1.e136333b.jpg";